module.exports = __webpack_public_path__ + "static/media/outbreak.351fada3.svg";